import React, { useRef } from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { formatPhone, formatLandlinePhone } from '../utils/methods';

// hover/focus 시 teal 테두리 강조. error/disabled 상태는 그대로 두기 위해 :not 으로 제외.
// MUI 기본 primary 색이 우선순위로 덮어쓰는 케이스가 있어 !important 로 보장.
const inputBorderStyle = {
  '& .MuiOutlinedInput-root:hover:not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
    borderColor: '#4AB3BC !important',
  },
  '& .MuiOutlinedInput-root.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
    borderColor: '#4AB3BC !important',
  },
};

export const FormInputPhone = ({
  name = '',
  control,
  className,
  disabled,
  rules,
  label,
  setValue = () => {},
  staticValue,
  placeholder,
  sx,
  tabIndex,
  onChange: onChangeCallback,
  isLandline = false, // 일반 전화번호인지 여부
}) => {
  const formatFunction = isLandline ? formatLandlinePhone : formatPhone;
  const prevValueRef = useRef('');
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const displayValue = staticValue ? staticValue : value;
        const formattedValue = displayValue ? formatFunction(displayValue) : '';

        return (
          <TextField
            helperText={error ? error.message : null}
            onKeyDown={e => {
              // 백스페이스 키를 눌렀을 때 하이픈 바로 앞에 커서가 있으면 하이픈도 함께 제거
              if (e.key === 'Backspace' && e.target.selectionStart === e.target.selectionEnd) {
                const cursorPos = e.target.selectionStart;
                const currentValue = e.target.value;

                // 커서가 하이픈 바로 뒤에 있으면 하이픈도 함께 제거
                if (cursorPos > 0 && currentValue[cursorPos - 1] === '-') {
                  e.preventDefault();
                  const newValue = currentValue.slice(0, cursorPos - 1) + currentValue.slice(cursorPos);
                  const digitsOnly = newValue.replace(/\D/g, '');
                  const formatted = formatFunction(digitsOnly);
                  onChange(formatted);
                  setValue(name, formatted);

                  // 커서 위치 조정
                  setTimeout(() => {
                    const newCursorPos = Math.max(0, cursorPos - 2);
                    e.target.setSelectionRange(newCursorPos, newCursorPos);
                  }, 0);
                }
              }
            }}
            onChange={e => {
              const inputValue = e.target.value;
              // 하이픈을 제거한 후 다시 포맷팅
              const digitsOnly = inputValue.replace(/\D/g, '');
              const formatted = formatFunction(digitsOnly);
              onChange(formatted);
              setValue(name, formatted);
              prevValueRef.current = formatted;

              if (onChangeCallback) {
                onChangeCallback({ ...e, target: { ...e.target, value: formatted } });
              }
            }}
            value={formattedValue}
            size="small"
            inputProps={{ maxLength: 14, tabIndex: tabIndex ?? 0 }}
            name={name}
            error={!!error}
            placeholder={placeholder}
            fullWidth
            disabled={disabled}
            label={label}
            variant="outlined"
            className={className}
            sx={{ ...inputBorderStyle, ...sx }}
          />
        );
      }}
    />
  );
};
